import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const stack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.5),
});

export const sectionTitle: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 700,
};

export const shipOption =
  (checked: boolean): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    p: { xs: 1.5, md: 1.75 },
    border: 1.5,
    borderColor: checked ? "primary.main" : "divider",
    borderRadius: 1.75,
    bgcolor: checked ? alpha(theme.palette.primary.main, 0.06) : "transparent",
    cursor: "pointer",
    transition: "all 0.2s ease",
  });

export const smsRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1.25),
});

export const footerRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.75),
  borderTop: 1,
  borderColor: "divider",
  pt: 2.25,
});

export const savedFlash: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  fontSize: "0.75rem",
  color: "success.main",
  fontWeight: 600,
};

export const sectionDivider: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.25),
  borderTop: 1,
  borderColor: "divider",
  pt: 2.25,
});
